import { SupportedTpaAppDefIds } from '@wix/a11y-adapters';
export let TpaDataKey = /*#__PURE__*/function (TpaDataKey) {
  TpaDataKey["ProGallery"] = "proGallery";
  TpaDataKey["WixVideo"] = "wixVideo";
  return TpaDataKey;
}({});
//# sourceMappingURL=types.js.map